// extracted by mini-css-extract-plugin
export var container = "_fp-1";
export var editor = "_fp-2";
export var resizable = "_fp-3";
export var wrapper = "_fp-0";